export default "__VITE_ASSET__16fcb267__"